import Experience from "./Experience";

export enum QrCodeTypes {
    ONE_SHOT = "ONE_SHOT",
    MULTI_VIDEO = "MULTI_VIDEO"
}

export interface QrCodeObject {
    _id: string;
    experiences: Experience[];
    pageId: number;
    qrcodeId: string;
    isOpen: boolean;
    customHTML:boolean;
    customCode?:string;
    customAPIVersion?:string;
    customFavicon?:string;
    customTitle?:string;
    videoMaxSize?: number;
    defaultVideoUrl?: string;
    htmlPage?: string;
    colors?: { [key: string]: string };
    logoB64?: string;
    faviconB64?: string;
    title?: string;
    texts: TextsData | {};
    getVideoAgreement?: string;
    videoAgreementMsg?: string;
    accountRequired?: "REQUIRED" | "OPTIONAL" | "NO_ACCOUNT";
    insertedAt?: Date;
    status: "BLANK" | "VIEWED" | "USED";
    xpReported?: boolean;
    xpBanned?: boolean;
    projectReported?: boolean;
    projectBanned?: boolean;
    type: QrCodeTypes;
    arEnabled?: boolean;
    fastUX?: boolean;
}

export interface TextsData {
    fr: {
        success: {
            doneMultiVideo: string;
        };
    };
    en: {
        success: {
            doneMultiVideo: string;
        };
    };
}